export default "__VITE_ASSET__CueDzt00__"